var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsConferenceCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#931d2f",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.20283 8.88867h4.18297l2.0915 4.70593-2.6143 1.4117c1.1199 2.0438 2.9578 3.6979 5.2287 4.7059l1.5686-2.3529 5.2288 1.8823v3.7647c0 .4993-.2203.978-.6126 1.331-.3922.3531-.9242.5514-1.4789.5514-4.0792-.2231-7.9266-1.7821-10.8164-4.3829-2.88974-2.6008-4.62198-6.0635-4.86987-9.7348 0-.4992.22035-.97799.61259-1.331.39223-.35301.92421-.55133 1.47891-.55133z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsConferenceCenters);
export default __webpack_public_path__ + "static/media/AmenitiesIconsConferenceCenters.3b3e421d96990bea8300bf17fc34922d.svg";
export { ForwardRef as ReactComponent };